<script setup lang="ts">
import { useSessionsStore } from '@kidzonet/dashboard-sessions-store'
import SessionList from '@kidzonet/sessions'
import SessionItem from '@kidzonet/sessions/src/Item.vue'

const store = useSessionsStore()
store.getSessions()
</script>

<template>
    <SessionList
        :loading="store.isSessionLoading"
    >
        <template #header>
            <span />
        </template>
        <template #item>
            <SessionItem
                v-for="item in store.sessions"
                :key="item.sessionId"
                :item="item"
                class="kidzonet-dashboard-widget"
                @delete-session="() => store.deleteSession(item.sessionId)"
            />
        </template>
    </SessionList>
</template>
